<sbnb-loading-spinner *ngIf="loading; else content" [minHeight]="'200px'"></sbnb-loading-spinner>

<ng-template #content>
  <div *ngIf="invoices && invoices.length === 0" class="table__no-items">You don't have any invoices yet.</div>

  <ng-container *ngIf="invoices && invoices.length > 0">
    <div fxLayout fxHide.lt-md class="rules__rule-header">
      <div fxFlex>Invoice</div>
      <div fxFlex>Date</div>
      <div fxFlex>Amount</div>
      <div fxFlex="92px">Download PDF</div>
    </div>

    <div *ngIf="downloading$ | async as downloadMap" class="mb-12">
      <ng-container *ngFor="let invoice of invoices">
        <div class="invoice" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
          <strong fxFlex fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
            <a class="link" [routerLink]="['/settings/active-properties']" [queryParams]="{ invoice_id: invoice.id }">
              Invoice #{{ invoice.id }}
            </a>
            <span *ngIf="invoice.isPaymentDue()" class="invoice__pill invoice__pill-due">Payment due</span>
            <span *ngIf="invoice.isPaid()" class="invoice__pill">Paid</span>
            <span *ngIf="invoice.isNotPaid()" class="invoice__pill invoice__pill-yellow">Not Paid</span>
            <span *ngIf="invoice.isPending()" class="invoice__pill invoice__pill-due">Pending</span>
            <span *ngIf="invoice.isVoided()" class="invoice__pill invoice__pill-black">Voided</span>
            <span *ngIf="invoice.isPosted()" class="invoice__pill invoice__pill-due">Posted</span>
          </strong>
          <span class="text__small" fxFlex fxHide.lt-md>{{ invoice.date | date: 'longDate' }}</span>
          <span class="text__small" fxFlex fxHide.lt-md>{{ invoice.amount }}</span>
          <button
            [disabled]="downloadMap[invoice.id]"
            class="button__small button__secondary"
            mat-flat-button
            (click)="downloadFile(invoice)">
            <span class="flex gap-2">
              <sbnb-loading-spinner [size]="16" *ngIf="downloadMap[invoice.id]"></sbnb-loading-spinner>
              <span>{{ downloadMap[invoice.id] ? 'Downloading' : 'Download' }}</span>
            </span>
          </button>
        </div>
        <ng-container *ngIf="invoice.credit_notes.length > 0">
          <div
            *ngFor="let cn of invoice.credit_notes"
            class="invoice credit_note"
            fxLayout
            fxLayoutAlign="start center"
            fxLayoutGap="16px">
            <strong fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
              <mat-icon color="accent">subdirectory_arrow_right</mat-icon>
              <span>Credit note #{{ cn.id }}</span>
              <span *ngIf="cn.isStatusAdjusted()" class="invoice__pill">Adjusted</span>
              <span *ngIf="cn.isStatusRefunded()" class="invoice__pill">Refunded</span>
              <span *ngIf="cn.isStatusRefundDue()" class="invoice__pill invoice__pill-yellow">Credited</span>
              <span *ngIf="cn.isStatusVoided()" class="invoice__pill invoice__pill-black">Voided</span>
            </strong>
            <span class="text__small" fxHide.lt-md fxFlex>{{ cn.date | date: 'longDate' }}</span>
            <span class="text__small" fxFlex fxHide.lt-md>{{ cn.amount }}</span>
            <button
              [disabled]="downloadMap[cn.id]"
              class="button__small button__secondary"
              mat-flat-button
              (click)="downloadFile(cn)">
              <span class="flex gap-2">
                <sbnb-loading-spinner *ngIf="downloadMap[cn.id]" [size]="16"></sbnb-loading-spinner>
                <span>{{ downloadMap[cn.id] ? 'Downloading' : 'Download' }}</span>
              </span>
            </button>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
